import React, { useEffect, useState } from 'react';
import {Container, Row, Col, Form, Button, InputGroup, FormControl} from 'react-bootstrap';
import { toast } from 'react-toastify';
import PasswordStrengthBar from 'react-password-strength-bar';
import {BsEye, BsEyeSlash} from "react-icons/bs";
import {changeUserPassword, changeUserPasswordStateClear} from "../../Redux/Auth/actions";
import {useDispatch, useSelector} from "react-redux";
export default function NewPassword() {
  const [validated, setValidated] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [currentPassword, setCurrentPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState()
  const [currentPasswordVisible, setCurrentPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false)
  const dispatch = useDispatch();
  const userData = useSelector(state => state.authReducer.data)
  const passwordUpdateSuccess = useSelector(state => state.authReducer.passwordUpdateSuccess)
  const passwordUpdateFailed = useSelector(state => state.authReducer.passwordUpdateFailed)
  const [passwordsMatchError, setPasswordsMatchError] = useState()
  const [passwordValidation, setPasswordValidation] = useState()
  const [currentPasswordMatchError, setCurrentPasswordMatchError] = useState("")
  const tokens = useSelector(state => state.authReducer.tokens)


  const toastConfig = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 1000,
  };
  useEffect(() => {
  }, [passwordUpdateSuccess]);
  const validatePassword = (password) => {
    if (password.length < 8) {
      return 'Password must be at least 8 characters';
    }
    if (!password.match(/\d/) || !password.match(/[a-zA-Z]/)) {
      return 'Password must contain at least 1 letter and 1 number';
    }
    return null;
  };
  const handleCurrentPasswordChange = (event) => {
    setCurrentPassword(event.target.value);
    setCurrentPasswordMatchError("")
  };
  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
    setPasswordValidation(validatePassword(event.target.value));
  };
  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
    setPasswordsMatchError("")
  };
  const handleToggleCurrentPasswordVisibility = () => {
    setCurrentPasswordVisible(!currentPasswordVisible);
  };
  const handleToggleNewPasswordVisibility = () => {
    setNewPasswordVisible(!newPasswordVisible);
  };
  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      toast.error('Please fill all the fields', toastConfig);
    } else if (newPassword !== confirmPassword) {
      setValidated(true);
      setPasswordsMatchError('New Password and Confirm Password do not match');
      toast.error('New Password and Confirm Password do not match', toastConfig);
      setValidated(false);

    } else {
      const passwordValidationResult = validatePassword(newPassword);
      if (passwordValidationResult) {
        setValidated(true);
        setPasswordValidation(passwordValidationResult);
        toast.error(passwordValidationResult, toastConfig);
      } else {
        setPasswordsMatchError('');
        setPasswordValidation('');
        let finalPayload = {
          userID: userData.id,
          currentPassword: currentPassword,
          newPassword: newPassword,
        };
        await changeUserPassword(dispatch, finalPayload);
      }
    }
  };

  useEffect(() => {
    if(passwordUpdateSuccess){
      toast.success("Password Updated Successfully", toastConfig)
    }
    return () => {
      changeUserPasswordStateClear(dispatch);
    };
  }, [passwordUpdateSuccess]);
  useEffect(() => {
    if (passwordUpdateFailed){
      toast.error(passwordUpdateFailed, toastConfig)
      if (passwordUpdateFailed === "Current password is incorrect"){
        setCurrentPasswordMatchError(passwordUpdateFailed)
        setValidated(false);
      }
    }
    return () => {
      changeUserPasswordStateClear(dispatch);
    };
  }, [passwordUpdateFailed]);
  return (
      <Container className='mt-5 p-3'>
        <Row>
          <Col>
            <div>
              <h4 className='main-h4-tag-large'>Password Change</h4>
              <Form noValidate validated={validated} onSubmit={handleSubmit} className=' w-75'>
                <Form.Group controlId="currentPassword" className='mt-3 custom-p-tag'>
                  <Form.Label>Current Password</Form.Label>
                  <InputGroup className="custom-border-input" >
                    <FormControl
                        type={currentPasswordVisible ? 'text' : 'password'}
                        placeholder="Enter Your Current Password"
                        name='currentPassword'
                        onChange={handleCurrentPasswordChange}
                        className={`custom-border ${currentPasswordMatchError ? 'is-invalid' : ''}`}
                        isInvalid={!!currentPasswordMatchError}
                        required
                    />
                    <InputGroup.Text className="custom-border-icons">
                      {currentPasswordVisible ? (
                          <BsEyeSlash onClick={handleToggleCurrentPasswordVisibility} />
                      ) : (
                          <BsEye onClick={handleToggleCurrentPasswordVisibility} />
                      )}
                    </InputGroup.Text>
                    <Form.Control.Feedback type="invalid" tooltip className={"mt-2"}>
                      {currentPasswordMatchError}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group controlId="NewPassword" className='mt-3 custom-p-tag'>
                  <Form.Label>New Password</Form.Label>
                  <InputGroup className="custom-border-input" >
                    <FormControl
                        type={newPasswordVisible ? 'text' : 'password'}
                        placeholder="Enter Your New Password"
                        name='newPassword'
                        onChange={handleNewPasswordChange}
                        className={`custom-border ${passwordValidation ? 'is-invalid' : ''}`}
                        required
                    />
                    <InputGroup.Text className="custom-border-icons">
                      {newPasswordVisible ? (
                          <BsEyeSlash onClick={handleToggleNewPasswordVisibility} />
                      ) : (
                          <BsEye onClick={handleToggleNewPasswordVisibility} />
                      )}
                    </InputGroup.Text>
                    <Form.Control.Feedback type="invalid" tooltip>
                      {passwordValidation}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
                <PasswordStrengthBar password={newPassword} />
                <Form.Group controlId="NewPassword" className=' custom-p-tag'>
                  <Form.Label>Confirm Password</Form.Label>
                  <InputGroup className="custom-border-input" >
                    <FormControl
                        type={newPasswordVisible ? 'text' : 'password'}
                        placeholder="Confirm Your New Password"
                        name='confirmPassword'
                        onChange={handleConfirmPasswordChange}
                        className={`custom-border ${passwordsMatchError ? 'is-invalid' : ''}`}
                        isInvalid={!!passwordsMatchError}
                        required
                    />
                    <InputGroup.Text className="custom-border-icons">
                      {newPasswordVisible ? (
                          <BsEyeSlash onClick={handleToggleNewPasswordVisibility} />
                      ) : (
                          <BsEye onClick={handleToggleNewPasswordVisibility} />
                      )}
                    </InputGroup.Text>
                    <Form.Control.Feedback type="invalid" tooltip className={"mt-2"}>
                      {passwordsMatchError}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
                <Button variant="primary" type="submit" className='custom-button mt-5'>
                  Update
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>


  );
}


